import $ from 'jquery'
import slickInit from './slick/slick';
export default () => {
	// Clear Form IDs for partial submissions
	localStorage.removeItem('nf_lead_id');
	localStorage.removeItem('current_form_id');
	localStorage.removeItem('current_collection');

	// For .geolocation fields: prevent Enter from clearing the input
	$(document).on('keydown', '.nf-form-content .geolocation', function (e) {
	  if (e.key === 'Enter') {
	    e.preventDefault();        // prevent form submit
	    e.stopPropagation();       // prevent any other handlers, e.g., clear button

	    // Trigger your existing change logic manually
	    $(this).trigger('change');
	  }
	});

	
	// Multipart change part - Request quote

	const dealerEmail = $('#request-quote input[data-key="dealeremail"]');
	const dealerName = $('#request-quote input[data-key="dealername"]');
	const dealerPhone = $('#request-quote input[data-key="dealerphone"]');

	if(typeof Marionette !== 'undefined') {

	    let currentPart = null;
	    let currentFormId = localStorage.getItem('current_form_id') || null;
	    let collection = null;

	    nfRadio.channel( 'nfMP' ).on('change:part', function(e) {

	    	currentPart   = e.currentElement.cid;
	    	currentFormId = e.formModel.id;
	    	collection = e.formModel.get('fields');    

	    	// Persist current form ID
	    	localStorage.setItem('current_form_id', currentFormId); 

	    	const $form = $('#nf-form-' + currentFormId + '-cont');
	    	const $errorField = $('.nf-field:has(#dealer-results-' + currentFormId + ')');

	        if (!$form.find('.nf-submit-next').length && $form.find('.submit-container').length) {
	            var submitBtn = $form.find('.submit-container');
	            var prevBtn = $form.find('.nf-next-previous');
	            prevBtn.append('<li class="nf-submit-next"></li>');
	            submitBtn.appendTo('#nf-form-' + currentFormId + '-cont .nf-submit-next');
	        }

	        // if ($('.geolocation').length > 0) {
	        //     console.log('step: geo found');

	        //     const userAddress = $('.geolocation').val() || localStorage.getItem('userAddress') || '';
	        //     if (userAddress) {
	        //         $('.geolocation').val(userAddress);
	        //         if (window.geo && typeof window.geo.initGeo === 'function') {
	        //             window.geo.initGeo(userAddress);
	        //         }
	        //     }
	            
	        //     if ($errorField.length) {
	        //         $form.find('.nf-next, input[type="submit"]').prop('disabled', true);
	        //     }
	        // }
	        if ($('.geolocation').length > 0) {
	            console.log('step: geo found');

	            const $geo = $('.geolocation');
	            const userAddress =
	                $geo.val() ||
	                localStorage.getItem('userAddress') ||
	                '';

	            if (userAddress) {
	                $geo.val(userAddress);

	                if (
	                    window.geo &&
	                    typeof window.geo.initGeo === 'function'
	                ) {
	                    window.geo.initGeo(userAddress);
	                } else {
	                    console.warn('Geolocation object is not available.');
	                }
	            }

	            if ($errorField.length) {
	                $form
	                    .find('.nf-next, input[type="submit"]')
	                    .prop('disabled', true);
	            }
	        }

	        const findNextBtn = $form.find('.find-next').parents('.nf-form-cont').find('.nf-next');

	        if (findNextBtn.length) {
	            findNextBtn.val('Match me with a Local Pro').addClass('save-lead');
	        }

	        const consent = $form.find('.consent');

	        if (consent.length) {
	        	consent.insertAfter($form.find('.nf-mp-footer'));
	        }

	        // Serialize collection minimally (keys, labels, values) if needed
	        const fieldsData = {};
	        if (collection && collection.models) {
	            collection.models.forEach(model => {
	                if (model.get('type') !== 'html') {
	                    fieldsData[model.get('key')] = {
	                        label: model.get('label'),
	                        value: model.get('value')
	                    };
	                }
	            });
	        }
	        localStorage.setItem('current_collection', JSON.stringify(fieldsData)); 

	    });

	    // Bind ONCE
	    $(document).on('click', '.save-lead', function () {
	        const $btn = $(this);
	        $btn.prop('disabled', true);
	        savePartialLead({currentFormId, collection}).always(() => $btn.prop('disabled', false));
	    });
	}

	// Clear lead id with form submission and save full link
	if (nfRadio !== typeof undefined) {
	    nfRadio.channel('forms').on('submit:response', function (response) {

	        const leadID = localStorage.getItem('nf_lead_id');

	            if (!leadID) return;

	            const formId = response.data.form_id;
	            const submittedFields = response.data.fields;
	            const $container = $('#dealer-results-' + formId);
	            const $form = $container.parents('.nf-form-layout').find('form');

	            var save = $form.parents('#find-dealer-form').length > 0 ? false : true;

	            if (save) {
	            	savePartialLead({
		                currentFormId: formId,
		                fields: submittedFields,
		                submission_id: leadID,
		                full: true
		            });
	            }

	            

	            localStorage.removeItem('nf_lead_id');
	            localStorage.removeItem('current_form_id');
	    });
	}

	// Save lead function
	function savePartialLead({
	    currentFormId,
	    collection = null,
	    fields = null,
	    submission_id = null,
	    full = false
	} = {}) {

	    if (!currentFormId) return $.Deferred().resolve();

	    let finalFields = {};

	    // If fields were passed directly (from localStorage)
	    if (fields && Object.keys(fields).length) {
	        Object.values(fields).forEach(field => {

	            if (field.type !== 'html') {

	                finalFields[field.key] = {
	                    label: field.label || '',
	                    value: field.value ?? ''
	                };
	            }
	        });
	    }
	    // Otherwise extract from collection (partial save)
	    else if (collection && collection.models) {
	        collection.models.forEach(model => {
	            if (model.get('type') !== 'html') {
	                finalFields[model.get('key')] = {
	                    label: model.get('label'),
	                    value: model.get('value')
	                };
	            }
	        });
	    }

	    const payload = {
	        action: 'nf_create_or_update_lead',
	        form_id: currentFormId,
	        fields: finalFields,
	        lead_id: localStorage.getItem('nf_lead_id'),
	        submission_id: submission_id,
	        full_submission: full,
	        nonce: nfLead.nonce
	    };

	    return $.post(ajax_url, payload).done(res => {
	        if (res.success && res.data.lead_id && !full) {
	            localStorage.setItem('nf_lead_id', res.data.lead_id);
	        }
	    });
	}

	// Single Product Template - Load Dealers

	$('body').on('click', '.clickable', function(e) {
	    const $target = $(e.currentTarget);

	    // Scope to the closest NF form
	    const $form = $target.closest('.nf-form-layout form');
	    const formID = $form.find('.block-find-dealer').data('form-id');

	    // Error field for this form
	    const $errorField = $form.find('.nf-field:has(#dealer-results-' + formID + ')');

	    $errorField.removeClass('nf-error');
	    $errorField.find('.nf-error-msg').hide();

	    // Enable the next button for this form
	    $form.find('.nf-next, input[type="submit"]').prop('disabled', false);

	    // Remove focused class for all clickable in this form
	    $form.find('.clickable').removeClass('focused');
	    $target.addClass('focused');

	    // Collect dealer info from clicked element
	    const email = $target.attr('data-email');
	    const name  = $target.attr('data-name');
	    const phone  = $target.attr('data-phone');

	    // Find the corresponding inputs inside this form
	    const dealerEmail = $form.find('input[data-key="dealeremail"]');
	    const dealerName  = $form.find('input[data-key="dealername"]');
	    const dealerPhone  = $form.find('input[data-key="dealerphone"]');

	    if (dealerEmail.length && dealerName.length) {
	        dispatchEvents(dealerEmail, dealerName, dealerPhone, email, name, phone);

	        // 1. Target the specific submit button using your classes
	        const submitButton = document.querySelector('input.ninja-forms-field.nf-element[type="submit"]');

	        if (submitButton) {
	          // 2. Scroll smoothly to the button, centering it in the viewport
	          submitButton.scrollIntoView({ 
	            behavior: "smooth", 
	            block: "center" 
	          });

	          // 3. Add the shake class to trigger the animation
	          submitButton.classList.add("visual-shake");

	          // 4. Remove the class after animation ends so it can be re-triggered later
	          submitButton.addEventListener("animationend", () => {
	            submitButton.classList.remove("visual-shake");
	          }, { once: true }); // { once: true } auto-removes this listener after it fires
	        }
	    }
	});

	$(document).on('change', '.geolocation', function (e) {

	    const $target = $(e.currentTarget);

	    // Scope to the closest NF form
	    const $form = $target.closest('.nf-form-layout form');

	    const formID = $target.parents('.block-find-dealer').length
	        ? $target.parents('.block-find-dealer').data('form-id')
	        : $form.find('.block-find-dealer').data('form-id');

	    // Error field for this form
	    const $errorField = $form.find(
	        '.nf-field:has(#dealer-results-' + formID + ':has(.clickable))'
	    );

	    const $slider = $('#dealer-results-' + formID);

	    if ($errorField.length) {
	        $errorField.addClass('nf-error');
	        $errorField.find('.nf-error-msg').show();

	        $form
	            .find('.nf-next, input[type="submit"]')
	            .prop('disabled', true);
	    }

	    // IMPORTANT: don't access window.geo until we know it exists
	    if (
	        window.geo &&
	        typeof window.geo.geocodeUserAddress === 'function'
	    ) {

	        const userAddress = $target.val();

	        if (userAddress !== localStorage.getItem('userAddress')) {

	            // Check if this geolocation field loads dealers
	            if (
	                $target.closest($slider).length ||
	                $target.parents('.nf-mp-body').find('.choose-dealer').length
	            ) {

	                $('.dealers-message, #dealer-results-' + formID + ' .nf-spinner').remove();

	                $slider
	                    .empty()
	                    .prepend(
	                        '<p class="dealers-message">Please wait, loading...</p>' +
	                        '<div class="nf-loading-spinner nf-spinner"></div>'
	                    );

	                $('#dealer-more-info .more-info-content').empty();

	                window.geo.geocodeUserAddress(userAddress, true);

	            } else {

	                window.geo.geocodeUserAddress(userAddress, false);

	            }
	        }

	    } else {

	        console.warn(
	            'Geolocation object is not available. ' +
	            'window.geo must be initialized before the .geolocation change handler runs.'
	        );

	    }

	    window.geo = window.geo || {};
	    window.geo.runGeo = true;

	});

	// $('body').on('change', '.geolocation', function (e) {

	//     const $target = $(e.currentTarget);

	//     // Scope to the closest NF form
	//     const $form = $target.closest('.nf-form-layout form');

	//     const formID = $target.parents('.block-find-dealer').length ? $target.parents('.block-find-dealer').data('form-id') : $form.find('.block-find-dealer').data('form-id');

	//     // Error field for this form
	//     const $errorField = $form.find('.nf-field:has(#dealer-results-' + formID + ':has(.clickable))');
	//     const $slider = $('#dealer-results-' + formID);

	//     if ($errorField.length) {
	//         $errorField.addClass('nf-error');
	//         $errorField.find('.nf-error-msg').show();
	//         $form.find('.nf-next, input[type="submit"]').prop('disabled', true);
	//     }

	//     if (window.geo.runGeo) {
	//         var userAddress = $(this).val();

	//         if (userAddress !== localStorage.getItem('userAddress')) {

	//             // Check if this geolocation field loads dealers
	//             if ($(this).closest($slider).length || $(this).parents('.nf-mp-body').find('.choose-dealer')) {
	//                 $('.dealers-message, #dealer-results-' + formID + ' .nf-spinner').remove();
	//                 $slider
	//                     .empty()
	//                     .prepend('<p class="dealers-message">Please wait, loading...</p><div class="nf-loading-spinner nf-spinner"></div>');

	//                 $('#dealer-more-info .more-info-content').empty();

	//                 // Convert address to coordinates and load dealers
	//                 window.geo.geocodeUserAddress(userAddress, true);
	//             } else {
	//                 // Just geocode, no dealer lookup
	//                 window.geo.geocodeUserAddress(userAddress, false);
	//             }
	//         }
	//     }

	//     window.geo.runGeo = true;
	// });


	// Find a Dealer page - on "Search" button click
	$( document ).on('click', ".find-dealer-submit", function(e) { 
	    var userAddress = $('.geolocation').val();

	    const $target = $(e.currentTarget);
	    const formID = $target.parents('.block-find-dealer').data('form-id');

	    // Add message to wait
	    $('#dealer-results-' + formID).empty().prepend('<p class ="dealers-message">Please wait, loading...</p><div class="nf-loading-spinner nf-spinner"></div>');
	    $('#dealer-more-info .more-info-content').empty();
	    // Convert address to coordinates and loadDealers (true), set false to just convert
	    if (window.geo && typeof window.geo.geocodeUserAddress === 'function') {
	        window.geo.geocodeUserAddress(userAddress, true);
	    }
	
	});

	$(document).on('click', '.request-quote-button', function(e) {
	    e.preventDefault();
	    $('.modal').fadeOut();

	    var email = $(e.currentTarget).attr('data-email');   
	    var name = $(e.currentTarget).attr('data-name'); 
	    var phone = $(e.currentTarget).attr('data-phone');

	    $(".find-dealer-rq").fadeIn();
	    resetNinjaForm();

	    $(document).one( 'click', '.find-dealer-rq input.ninja-forms-field', function() {

	        var dealerEmail = $('.find-dealer-rq input[data-key="dealeremail"]');
	        var dealerName = $('.find-dealer-rq input[data-key="dealername"]');
	        var dealerPhone = $('.find-dealer-rq input[data-key="dealerphone"]');

	        if (dealerEmail.length) {
	            dispatchEvents(dealerEmail, dealerName, dealerPhone, email, name, phone);
	        }
	        
	    });
	});

	function dispatchEvents(dealerEmail, dealerName, dealerPhone, email, name, phone) {
	    dealerEmail.val(email).trigger( 'change' );
	    dealerName.val(name).trigger( 'change' );
	    dealerPhone.val(phone).trigger( 'change' );
	    // trigger event change the hard way - no other way works
	    var evt = document.createEvent("HTMLEvents");
	    evt.initEvent("change", true, true);
	    dealerEmail[0].dispatchEvent(evt);
	    dealerName[0].dispatchEvent(evt);
	    dealerPhone[0].dispatchEvent(evt);
	    console.log(dealerName.val());
	}

	// Create a global cache for reCAPTCHA widget IDs (optional)
	window.recaptchaWidgets = window.recaptchaWidgets || {};

	// Function to reset the Ninja Form
	function resetNinjaForm() {
	    // Target the Ninja Form container
	    const $formContainer = $('.find-dealer-rq .nf-form-cont');
	    if ($formContainer.length !== 1) {
	        console.error('Expected exactly one .nf-form-cont element, found:', $formContainer.length);
	        return;
	    }
	    const containerID = '#' + $formContainer.attr('id');
	    const $form = $formContainer.find('form');

	    // Reset the form fields
	    if ($form.length && $form[0]) {
	        $form[0].reset();
	    } else {
	        console.warn('No form found in container:', containerID);
	    }

	    // Show the form again
	    $formContainer.find('.nf-form-wrap, form').show();

	    // Hide the success message
	    $formContainer.find('.nf-response-msg').hide();

	    // Function to handle reCAPTCHA reset/render
	    function handleRecaptcha() {
	        if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render === 'function') {
	            $formContainer.find('.g-recaptcha').each(function (index, el) {
	                // Ensure element has a unique ID
	                if (!el.id) {
	                    el.id = `recaptcha-${index}`;
	                }

	                // Check if a widget is already rendered
	                const isRendered = el.hasAttribute('data-widget-id') || !!$(el).find('.g-recaptcha-response').length;

	                if (isRendered) {
	                    // Reset existing widget
	                    const widgetId = el.getAttribute('data-widget-id');
	                    if (widgetId && grecaptcha.getResponse(widgetId) !== undefined) {
	                        grecaptcha.reset(widgetId);
	                    }
	                } else {
	                    // Render new widget and store widget ID
	                    const siteKey = el.getAttribute('data-sitekey');
	                    if (!siteKey) {
	                        console.error(`No data-sitekey found for reCAPTCHA element: ${el.id}`);
	                        return;
	                    }
	                    const widgetId = grecaptcha.render(el, { sitekey: siteKey });
	                    el.setAttribute('data-widget-id', widgetId);
	                    window.recaptchaWidgets[el.id] = widgetId; // Store in global cache
	                }
	            });
	        } else {
	            console.warn('grecaptcha not yet ready');
	        }
	    }

	    // Wait for reCAPTCHA to be ready
	    function waitForRecaptcha(callback, attempts = 10, interval = 300) {
	        if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render === 'function') {
	            callback();
	        } else if (attempts > 0) {
	            setTimeout(() => waitForRecaptcha(callback, attempts - 1, interval), interval);
	        } else {
	            console.error('grecaptcha failed to load after multiple attempts');
	            // Optionally notify user, e.g., show an error message on the form
	            $formContainer.append('<div class="error">Failed to load reCAPTCHA. Please refresh the page.</div>');
	        }
	    }

	    // Execute reCAPTCHA handling
	    waitForRecaptcha(handleRecaptcha);

	    // Reinitialize Ninja Forms frontend
	    if (typeof window.nfFrontEnd !== 'undefined') {
	        $(document).trigger('nfFormReady');
	    } else {
	        console.error('Ninja Forms frontend scripts are not loaded.');
	        // Optionally notify user
	        $formContainer.append('<div class="error">Form functionality may be limited. Please refresh the page.</div>');
	    }
	}

	$(document).on('click', '.close', function() {
	    $(this).parent().fadeOut();
	}); 

	$(document).on('click', function(e) {
	    const $modal = $('#dealer-more-info');

	    // Only proceed if this modal is visible
	    if ($modal.is(':visible') && !$(e.target).closest('#dealer-more-info .modal-content').length) {
	        $modal.fadeOut();
	    }
	});

	$(document).on('click', '.click-reveal:not(.revealed)', function (e) {
	    e.preventDefault();
	    var reveal = $(this).data('reveal');
	    $(this).find('span').text(reveal);
	    $(this).addClass('revealed');
	}); 

	$(document).on('click', '.dealer-more-info', function(e) {
	    e.preventDefault();
	    e.stopPropagation(); // prevent it from bubbling up

	    var dealerID = $(this).data('id');
	    $('.dealer-block-wrapper').hide();
	    $('.dealer-block-wrapper[data-dealer="' + dealerID + '"]').show();
	    $('#dealer-more-info').fadeIn(function () {
	        slickInit();
	    });
	});  

	// Function to apply clear button to Ninja Forms inputs
	function addClearButtons() {
	  $('.nf-form-content input[type="text"], .nf-form-content input[type="email"], .nf-form-content input[type="phone"]').each(function () {
	    const $input = $(this);

	    if ($input.parent('.nf-clear-wrapper').length === 0) {
	      $input.wrap('<div class="nf-clear-wrapper"></div>');

	      const $btn = $('<button type="button" class="nf-clear-btn" aria-label="Clear">&times;</button>');
	      $input.after($btn);

	      // Show/hide button
	      $input.on('input', function () {
	        $btn.toggle(this.value.length > 0);
	      });

	      // Clear input (and prevent any form interaction)
	      $btn.on('click', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        $input.val('').trigger('input').focus();
	      });
	    }
	  });
	}

	// Initial run
	addClearButtons();

  	// Observe nf-rows-wrap nodes inside the body
  	const observer = new MutationObserver(function (mutations) {
      mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
              const $node = $(node);

              const formID = $node.parents('.block-find-dealer').data('form-id');

              // Handle dealer selection logic
              const $form = $node.closest('.nf-form-layout form');

              // Error field for this form
              const $errorField = $form.find('.nf-field:has(#dealer-results-' + formID + ':has(.clickable))');
              const $slider = $('#dealer-results-' + formID);

              // Proceed if the added node is <nf-rows-wrap> or contains one
              if ($node.is('nf-rows-wrap') || $node.find('nf-rows-wrap').length) {

                  // Add clear buttons to the fields inside this row container
                  addClearButtons(node);

                  if (!$form.find('.clickable.focused').length &&
                      $form.find('.clickable').length) {

                      // Disable "Next" button until a contractor is selected
                      $form.find('.nf-next, input[type="submit"]').prop('disabled', true);                      

                      if (!$errorField.find('.nf-error-msg').length) {
                          $errorField.addClass('nf-error');
                          $errorField.find('.nf-field-element')
                                     .after('<div class="nf-error-msg">Please select a contractor from whom you would like to request a quote.</div>');
                      }
                  }
              }
          });
      });
    });

    // Start observing the document body (or a more specific container)
    observer.observe(document.body, {
      childList: true,
      subtree: true
  	});
}
